import { useEffect, useState } from "react";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";
import { getRealm, getRestServer } from "../AuthProvider";
import FullscreenLoader from '../components/FullScreenLoader';
import OIDCError from "../components/OIDCError";

export default function Auth() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [serverUrl] = useState(getRestServer());
  const [realm] = useState(getRealm());

  useEffect(() => {
    (async () => {
        try {
            if (!auth.isLoading && auth.isAuthenticated) {
                const res = await fetch(`${serverUrl}/api/${realm}/user/login`, {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${auth.user.id_token}`,
                    },
                });

                console.log(res, auth);
                navigate("/");
            } else if (auth.error) {
                console.error("OIDC Error:", auth.error);
            }
        } catch (e) {
            console.error(e);
        }
    })();
  }, [auth, navigate, realm, serverUrl]);

  if (auth.isLoading) return <FullscreenLoader text="Loading authentication..." />;
  if (auth.error) return <OIDCError error={auth.error}/>;

  return <FullscreenLoader text="Processing login..." />;
}
